export const ROOT_HOME = '/';
export const LOGIN = '/login';
export const AUTH = '/auth';
export const USERS = '/usuarios';
export const REPORTS = '/reportes';
export const HEALTH_CHECK = '/healthcheck';
export const TEAMS = '/teams';
export const ADMIN = '/admin';
export const B2B = '/b2b';
export const IA = '/ia';
export const PRD = `${IA}/prd`;

